import type { EditorialPageData } from "../types";

export const LEGACY_EDITORIAL_SLUG = "editorial-guidelines";
export const DEFAULT_EDITORIAL_SLUG = "editorial-policy";

export const resolveEditorialCanonicalPath = (data: EditorialPageData): string =>
  data.canonicalPath?.trim() || `/blog/${data.urlSlug?.trim() || DEFAULT_EDITORIAL_SLUG}`;

export const resolveEditorialCanonicalSuffix = (
  data: EditorialPageData,
  langPrefix?: string,
): string => {
  const path = resolveEditorialCanonicalPath(data);
  return langPrefix ? `/${langPrefix}${path}` : path;
};
